import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, useNavigate } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import { RenderedPage } from '../../cdl-react-components/components'
import Link from '../Link'
import ArticleSamples from '../ArticleSamples'
import ContentGroups from '../ContentGroups'
import RecentActivityMap from '../RecentActivityMap'
import RecentArticles from '../RecentArticles'
import EPAnalysis from '../EPAnalysis'
import { replaceAll, contains, graphqlFetch } from '../../cdl-react-components/utilities'
import { APP_NAME } from '../../../utilities/constants'
import { setConfiguration } from '../../../store/actions'

const DefaultRoute = () => {
    const pathname = useParams()['*']
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const pageIds = useSelector(_ => _.data.configuration.pageIds)
    const [pageId, setPageId] = useState()

    useEffect(() => {        
        // Get and store list of PageIds from Django for validation
        if (!pageIds) {                
            graphqlFetch('wcms3', `
                query {
                    pages {
                        pageId
                    }
                } `)
                .then(res => {
                    const pageIds = res.data.pages.map(page => page.pageId)
                    dispatch(setConfiguration({ pageIds }))
                })
        }
    }, [dispatch, pageIds])

    useEffect(() => {
        if (pageIds) {
            // Check for valid pageId. If invalid, check if the route is from drupal.
            const pageId = APP_NAME + replaceAll(window.location.pathname, { '/': '__' })
            if (pageIds && contains(pageIds, pageId))
                setPageId(pageId)
            else {
                (async () => {
                    let redirectRoute = '/'
                    const { pathname } = window.location
                    const route = await tryGetDrupalRoute(pathname.substr(1))
                    if (route)
                        redirectRoute = route

                    navigate(redirectRoute)
                })()
            }
        }
    }, [pageIds, pathname, navigate])

    const tryGetDrupalRoute = async (pathname) => {
        const routeRes = await graphqlFetch('wcms3', `
            query {
                drupalRoutes (
                    where: { route: { eq: "${pathname}" }}
                ) {
                    id
                    nid    
                    type    
                }
            }`)

        if (routeRes.data.drupalRoutes.length > 0 &&
            routeRes.data.drupalRoutes[0].type === 'article'
        ) {
            const route = routeRes.data.drupalRoutes[0]
            const articleRes = await graphqlFetch('wcms3', `
                query {
                    articles(where: { nid: { eq: ${route.nid} } }) {
                        items {
                            id
                        }
                    }
                }`)
            
            if (articleRes.data.articles.items.length > 0) {
                const article = articleRes.data.articles.items[0]
                return `/article/${article.id}`
            }
            // Else article not found, no valid route
        }
        
        return null        
    }

    return pageId ? (
        <RenderedPage
            pageId={pageId}
            components={{
                Link,
                ArticleSamples,
                ContentGroups,
                RecentActivityMap,
                RecentArticles,
                EPAnalysis,
                HashLink
            }} />
    ) : null
}



export default DefaultRoute